(function () {
  'use strict';

  var root = document.getElementById('preworn-order-activity');
  if (!root || root.getAttribute('data-initialized') === 'true') return;
  root.setAttribute('data-initialized', 'true');

  var endpoint = root.getAttribute('data-endpoint');
  var pollInterval = Number(root.getAttribute('data-poll-ms')) || 60000;
  var displayDuration = Number(root.getAttribute('data-display-ms')) || 7000;
  var maximumBackoff = 300000;
  var storageKey = 'preworn-order-activity-event-v2';
  var previewMode = new URLSearchParams(window.location.search).get('activity_preview') === '1';

  var image = root.querySelector('[data-order-activity-image]');
  var imageWrap = root.querySelector('[data-order-activity-image-wrap]');
  var title = root.querySelector('[data-order-activity-title]');
  var price = root.querySelector('[data-order-activity-price]');
  var count = root.querySelector('[data-order-activity-count]');
  var time = root.querySelector('[data-order-activity-time]');
  var similar = root.querySelector('[data-order-activity-similar]');
  var dismiss = root.querySelector('[data-order-activity-dismiss]');

  var lastEventId = readStoredEventId();
  var timer = null;
  var hideTimer = null;
  var activeRequest = null;
  var currentDelay = pollInterval;
  var previewShown = false;

  function readStoredEventId() {
    try {
      return window.sessionStorage.getItem(storageKey);
    } catch (error) {
      return null;
    }
  }

  function storeEventId(eventId) {
    lastEventId = eventId;
    try {
      window.sessionStorage.setItem(storageKey, eventId);
    } catch (error) {
      // Storage can be unavailable in privacy modes; in-memory tracking still works.
    }
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    var jitter = Math.floor(Math.random() * 5000);
    timer = window.setTimeout(poll, delay + jitter);
  }

  function validPayload(payload) {
    return payload &&
      payload.ok === true &&
      payload.event &&
      typeof payload.event.id === 'string' &&
      payload.event.id.length > 0;
  }

  function formatPrice(value, currency) {
    var number = Number(value);
    if (!isFinite(number)) return '';

    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currency || 'GBP'
      }).format(number);
    } catch (error) {
      return '£' + number.toFixed(2);
    }
  }

  function safeImageUrl(value) {
    if (!value) return '';

    try {
      var parsed = new URL(value, window.location.origin);
      return parsed.protocol === 'https:' ? parsed.href : '';
    } catch (error) {
      return '';
    }
  }

  function relativeTime(value) {
    if (!value) return '';
    var parsed = new Date(String(value).replace(' ', 'T'));
    if (!isFinite(parsed.getTime())) return '';
    var minutes = Math.max(0, Math.floor((Date.now() - parsed.getTime()) / 60000));
    if (minutes < 1) return '· JUST NOW';
    if (minutes < 60) return '· ' + minutes + ' MIN AGO';
    var hours = Math.floor(minutes / 60);
    if (hours < 24) return '· ' + hours + (hours === 1 ? ' HR AGO' : ' HRS AGO');
    return '· RECENTLY';
  }

  function hide() {
    window.clearTimeout(hideTimer);
    root.classList.remove('is-visible');
    window.setTimeout(function () {
      if (!root.classList.contains('is-visible')) root.hidden = true;
    }, 260);
  }

  function show(payload) {
    var event = payload.event;
    var stats = payload.stats || {};
    var imageUrl = safeImageUrl(event.image_url);
    var itemsToday = Number(stats.items_today) || 0;

    title.textContent = event.title || 'A preloved item';
    price.textContent = formatPrice(event.price, event.currency);
    if (time) time.textContent = relativeTime(event.occurred_at);
    if (similar) similar.href = event.similar_url || '/search?q=' + encodeURIComponent(event.title || 'Preloved fashion');
    count.textContent = itemsToday === 1
      ? '1 item sold today'
      : itemsToday + ' items sold today';

    if (imageUrl) {
      image.hidden = false;
      imageWrap.hidden = false;
      image.src = imageUrl;
      image.alt = '';
      image.onerror = function () {
        image.hidden = true;
        imageWrap.hidden = true;
      };
    } else {
      image.removeAttribute('src');
      image.hidden = true;
      imageWrap.hidden = true;
    }

    root.hidden = false;
    window.requestAnimationFrame(function () {
      root.classList.add('is-visible');
    });

    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(hide, displayDuration);
  }

  function poll() {
    if (document.visibilityState === 'hidden') {
      schedule(pollInterval);
      return;
    }

    if (activeRequest) activeRequest.abort();
    activeRequest = new AbortController();

    var requestTimeout = window.setTimeout(function () {
      activeRequest.abort();
    }, 5000);

    fetch(endpoint, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      cache: 'no-cache',
      headers: { Accept: 'application/json' },
      signal: activeRequest.signal
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Order activity returned HTTP ' + response.status);
        return response.json();
      })
      .then(function (payload) {
        if (!validPayload(payload)) throw new Error('Order activity payload was invalid');

        currentDelay = pollInterval;

        if (previewMode && !previewShown) {
          previewShown = true;
          storeEventId(payload.event.id);
          show(payload);
          return;
        }

        // Establish a baseline silently on the shopper's first request.
        if (lastEventId === null) {
          storeEventId(payload.event.id);
          return;
        }

        if (payload.event.id !== lastEventId) {
          storeEventId(payload.event.id);
          show(payload);
        }
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') {
          currentDelay = Math.min(Math.max(currentDelay * 2, 120000), maximumBackoff);
          return;
        }

        currentDelay = Math.min(Math.max(currentDelay * 2, 120000), maximumBackoff);
      })
      .finally(function () {
        window.clearTimeout(requestTimeout);
        activeRequest = null;
        schedule(currentDelay);
      });
  }

  dismiss.addEventListener('click', hide);

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      if (activeRequest) activeRequest.abort();
      window.clearTimeout(timer);
      return;
    }

    currentDelay = pollInterval;
    schedule(1000);
  });

  // Spread first requests across visitors instead of creating a synchronized spike.
  schedule(4000 + Math.floor(Math.random() * 8000));
})();
